var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tooltip', {
    attrs: {
      "text": _vm.$t("BackendResourceEnum.".concat(_vm.reference.refType))
    }
  }, [_vm.icon ? _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.icon))])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }